import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { notification, Button, Row, Divider, Col, Table, Modal } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getArticles, deleteArticle, getLanguages } from "../../services/api";
import { DeleteOutlined, FileAddOutlined } from '@ant-design/icons';
import PageTitle from "../../components/page-title";
import { TableLanguage } from "../../styles/global";

const Blogs = () => {
    const queryClient = useQueryClient();
    const [ ntf, contextHolder ] = notification.useNotification();
    const {data} = useQuery({ queryKey: ['todos'], queryFn: getArticles });
    const { data: dataLanguages, isLoading: isLoadingLanguages } = useQuery(['languages'], () => getLanguages(), {cacheTime: 120000, staleTime: 120000});
    const {mutate: mutateDeleteArticle} = useMutation(deleteArticle)
    const [isOpenDeleteArticleModal, setisOpenDeleteArticleModal] = useState({open: false, id: 0});
  
    const handleDelete = () => {
      mutateDeleteArticle({id: isOpenDeleteArticleModal.id}, {
        onSuccess() {
          queryClient.invalidateQueries(['todos']);
          setisOpenDeleteArticleModal({open: false, id: 0});
          ntf.success({
            message: `Success`,
            description: "Blog is deleted with success!",
            placement: "bottomLeft",
          });
        },
        onError() {
          ntf.error({
            message: `Error`,
            description: "Something gonne wrong!",
            placement: "bottomLeft",
          });
        },
      })
    }

    const showLanguage = (langId: string) => {
      const result = dataLanguages && dataLanguages.find((language: any) => language.id === langId);
      return {...result};
    }
  
    const columns: any = [
      {
        title: 'Blog Id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title',
        render: (title: string, record: any) => <Link to={`/blogs/${record.id}`}>{title}</Link>
      },
      {
        title: 'Language',
        dataIndex: 'language_id',
        key: 'language_id',
        render: (key: string, record: any) => showLanguage(key).name ? <TableLanguage>{showLanguage(key).name}</TableLanguage> : <TableLanguage notSet={true}>not set</TableLanguage>
      },
      {
        title: 'Date Added',
        dataIndex: 'date_added',
        key: 'date_added'
      },
      {
        title: 'Delete',
        dataIndex: 'delete',
        key: 'delete',
        align: 'center',
        width: '50px',
        render: (id: any, record: any) => <Button icon={<DeleteOutlined />} danger onClick={() => setisOpenDeleteArticleModal({open: true, id: record.id})} />
      },
    ];
    
  
    return (
      <Row justify="center">
        {contextHolder}
        <PageTitle text={`Blogs`} />
        <Col span={20}>
            <Row>
                <Col>
                    <Link to="/blogs/create">
                        <Button type="primary" icon={<FileAddOutlined />}>Create Blog</Button>
                    </Link>
                    <Divider></Divider>
                </Col>
            </Row>
        </Col>
        <Col span={20}>
          <Table dataSource={data} columns={columns} />;
        </Col>
        <Modal title="Delete Blog?" open={isOpenDeleteArticleModal.open} onOk={() => handleDelete()} onCancel={() => setisOpenDeleteArticleModal({open: false, id: 0})}>
          Do you really want to delete it?
        </Modal>
      </Row>
    )
  }
  
  export default Blogs